import { useCallback, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { getReadableDate } from "../../utils";
import ProgressiveControl from "../common/ProgressiveControl";
import ConfirmationWrapper from "../common/ConfirmationWrapper";
import DialogEditBranch from "./DialogEditBranch";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";
import { TEXT_NORMAL, TEXT_SMALL } from "../../style";

export default function Branch({ id, title, address, description, active, updated_at, setBranches }) {
    const { requestAPI, showToast } = useAppContext();

    const [deleting, setDeleting] = useState();
    const [dialogEditBranch, setDialogEditBranch] = useState({ visible: false });

    const closeDialogEditBranch = useCallback(() => {
        setDialogEditBranch((prev) => ({ ...prev, visible: false }));
    }, []);

    const deleteBranch = useCallback(() => {
        requestAPI({
            requestPath: `branches/${id}`,
            requestMethod: "DELETE",
            setLoading: setDeleting,
            parseResponseBody: false,
            onResponseReceieved: (_, responseCode) => {
                if (responseCode === 204) {
                    showToast({ severity: "success", summary: "Deleted", detail: "Branch Deleted", life: 1000 });
                    setBranches((prev) => prev?.filter((branch) => branch?.id !== id));
                } else {
                    showToast({ severity: "error", summary: "Failed", detail: "Failed To Delete Branch !", life: 2000 });
                }
            },
        });
    }, [id, requestAPI, setBranches, showToast]);

    return (
        <div
            className={`flex gap-3 align-items-center border-1 border-gray-300 border-round py-2 px-3 overflow-hidden text-white ${
                active ? "bg-green-500" : "bg-red-500"
            }`}
        >
            <div className="flex flex-column flex-1 gap-1 overflow-hidden">
                <span className={`${TEXT_NORMAL} font-semibold`}>
                    {id}. {title}
                </span>
                {address ? <span className={`${TEXT_SMALL} white-space-nowrap overflow-hidden text-overflow-ellipsis`}>{address}</span> : null}
                {description ? <span className={`${TEXT_SMALL} white-space-nowrap overflow-hidden text-overflow-ellipsis`}>{description}</span> : null}
                <span className={TEXT_SMALL}>Updated {getReadableDate({ date: updated_at })}</span>
            </div>

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.UPDATE_BRANCH}>
                <i
                    className="pi pi-pencil"
                    onClick={() =>
                        setDialogEditBranch({
                            visible: true,
                            setBranches,
                            id,
                            title,
                            address,
                            description,
                            active,
                            closeDialog: closeDialogEditBranch,
                        })
                    }
                />
            </HasRequiredAuthority>

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.DELETE_BRANCH}>
                <ProgressiveControl
                    loading={deleting}
                    control={
                        <ConfirmationWrapper action={deleteBranch}>
                            <i className="pi pi-trash" />
                        </ConfirmationWrapper>
                    }
                />
            </HasRequiredAuthority>

            {dialogEditBranch?.visible && <DialogEditBranch {...dialogEditBranch} />}
        </div>
    );
}
